// Constant Data for Merchant::Inbound

export const INBOUND_TYPE = {
  DROPOFF : 'dropoff',
  PICKUP  : 'pickup',
  LISTING : 'listing'
}

export const RECEIVED_STATUS = {
  RECEIVED : 'received',
  PENDING  : 'pending',
  CANCELED : 'canceled'
}

export const SCHEDULED = {
  YES : 'true',
  NO  : 'false'
}

export const RESTOCK_FLOW = {
  YES : 'true',
  NO  : 'false'
}

export const INVENTORY_BATCH_STATUS = {
  PENDING   : 'pending',
  PARTIAL   : 'partial',
  COMPLETED : 'completed'
}

export const CURATION_STATUS = {
  PENDING          : 'pending',
  PHYSICAL_CURATED : 'physical_curated',
  PHOTO_CURATED    : 'photo_curated'
}

export const INBOUND_PROCESS_STATUS = {
  PENDING    : 'pending',
  READY_LIVE : 'ready_live',
  COMPLETED  : 'completed'
}

export const INBOUND_MERCHANT_LIST = {
  LISTING: 'listing'
}

export const INBOUND_MERCHANT_FULL = {
  DROPOFF : 'dropoff',
  PICKUP  : 'pickup'
}

export const RESTOCK = {
  YES : 'yes',
  NO  : 'no'
}

export const PROCESSING_FEE = {
  YES : 'yes',
  NO  : 'no'
}